export const Benefits = {
  FOOD: 'food',
  DEVICES: 'devices',
  CAR: 'car',
  TRAINING: 'training',
  WELFARE: 'welfare',
  INSURANCE: 'insurance',
  REMOTE_WORKING: 'remote_working',
};

export const BenefitIcons = {
  [Benefits.FOOD]: 'icn-coffee-togo',
  [Benefits.DEVICES]: 'icn-laptop',
  [Benefits.CAR]: 'icn-car',
  [Benefits.TRAINING]: 'icn-group',
  [Benefits.WELFARE]: 'icn-home-heart',
  [Benefits.INSURANCE]: 'icn-user-heart',
  [Benefits.REMOTE_WORKING]: 'icn-home-outline',
};

export const MotivationValues = {
  HIGH: 'high',
  MEDIUM: 'medium',
  LOW: 'low',
};

export const MotivationIcons = {
  [MotivationValues.HIGH]: 'icn-super-happy',
  [MotivationValues.LOW]: 'icn-confused',
  [MotivationValues.MEDIUM]: 'icn-happy',
};

export const CANDIDATE_EVENT_TYPES = {
  PRESENTED: 'presented',
  SEEN_BY_CLIENT: 'seen_by_client',
  LIKED_BY_CLIENT: 'liked_by_client',
  DISLIKED_BY_CLIENT: 'disliked_by_client',
  TECHNICAL_REPORT_INCOMING: 'technical_report_incoming',
  TECHNICAL_REPORT_FILLED_IN: 'technical_report_filled_in',
  TECHNICAL_REPORT_PUBLISHED: 'technical_report_published',
  CLIENT_INTERVIEW_TO_BE_SCHEDULED: 'client_interview_to_be_scheduled',
  CLIENT_INTERVIEW_INCOMING: 'client_interview_incoming',
  CLIENT_INTERVIEW_DONE: 'client_interview_done',
  OFFER_INCOMING: 'offer_incoming',
  OFFER_MADE: 'offer_made',
  OFFER_ACCEPTED: 'offer_accepted',
  OFFER_DECLINED: 'offer_declined',
  CANDIDATE_WITHDREW: 'candidate_withdrew',
  CANDIDATE_REJECTED: 'candidate_rejected',
};
